// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"67":"supplier","187":"search","275":"article","884":"admin"}[chunkId] + "." + {"67":"390d6f79","187":"f0b30dd4","275":"c613fe1f","884":"b83269bd"}[chunkId] + ".css";
};